import { useCallback, useEffect } from 'react';

export interface UseHandleClickOutsideProps {
    clicked: boolean;
    dropdownContainerRef: React.RefObject<HTMLDivElement | null>;
    setButtonClicked: (value: boolean) => void;
}

export const useHandleClickOutside = ({
    clicked,
    dropdownContainerRef,
    setButtonClicked,
}: UseHandleClickOutsideProps) => {
    const handleClickOutside = useCallback((event: MouseEvent) => {
        const path = event.composedPath();
        if (dropdownContainerRef.current && !path.includes(dropdownContainerRef.current)) {
            setButtonClicked(false);
        }
    }, []);

    useEffect(() => {
        if (clicked) {
            document.addEventListener('mousedown', handleClickOutside);
        }
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [clicked, handleClickOutside]);

    return handleClickOutside;
};
